module.exports = __webpack_public_path__ + "media/2-21.df032774.wav";